export default "__VITE_ASSET__M0z0O2xS__"